import React from 'react'
import Modal from '../Modal'
import Feedback from '../feedback'
import useIsMobile from '../../hooks/useIsMobile'
const SurveyInvitePopup = ({
	isOpen,
	onClose,
	onConfirm,
	title = '¿Tenés un minuto?',
	bodyText = 'Nos interesa tu opinión.\nLa encuesta tomará solo un minuto.',
	buttonLabel = 'Ir a la encuesta'
}) => {
	const isMobile = useIsMobile()
	if (!isOpen) return null
	return (
		<Modal onClose={onClose} widthDesktop="480px" isFullHeight={isMobile}>
			<Feedback
				title={title}
				bodyText={bodyText}
				buttonLabel={buttonLabel}
				onClickButton={onConfirm}
				textGap={14}
				gap={32}
				isSucces={false}
				isError={false}
				isModal={true}
				padding={24}
				widthDesktop="480px"
			/>
		</Modal>
	)
}

export default SurveyInvitePopup
